import React from "react";
import "./Contact.css";
import Nav from "../Nav";
import { Link,withRouter} from "react-router-dom";


class Contact  extends React.Component {
    render() {
        return (
            <div>
              <Nav/>
              <p style={{fontSize: '34px', color: 'green', marginTop: '10%'}} className="text-center">Send Message</p>
                <div class="container mx-auto mb-5">
      <div style={{boxShadow: '0 20px 50px rgba(0,0,0,.8)', background: 'linear-gradient(to right, #E91E63, #3F51B5)', height: '450px'}} class=" mt-5 mb-5">
        <form id="contact-form" action="https://formspree.io/samuel.worwui@gmail.com" method="POST">
          <div class="row d-flex form-group center-block justify-content-center container">
          <div class="col-12 col-md-6 col-lg-3 mt-5" ><label for="inputName">Name</label>
            <input type="text" class="form-control contact-input" id="inputName" placeholder="Name" name="name"/></div>
            <div class="col-12 col-md-6 col-lg-3 mt-5"><label for="inputEmail">Email</label>
            <input type="email" class="form-control contact-input" id="inputEmail" placeholder="Email" name="_replyto"/></div>
        </div>
        <div class="row justify-content-center container">
          <div class="col-md-5 col-sm-12 form-group center-block text-center justify-content-center mt-5">
            <label for="inputMessage">Message</label>
            <textarea id="inputMessage" class="form-control contact-input" rows="3" placeholder="Your Message" name="message"></textarea>
          </div>
        </div>
        <div class="row justify-content-center container">
          <div class="col-md-5 col-sm-12 text-center mb-5">
            <button style={{color: '#fff', background: '#E81586'}} class="btn" type="submit" id="email-submit-btn" value="Send">
              Submit
            </button>
          </div>
        </div>
        </form>
      </div>
    </div>






            </div>
        )
    }
}
export default withRouter(Contact);